import React, { useState, useEffect } from 'react'

const NoteEditor = ({ proxy, apiClient, onSave, onCancel }) => {
    const [note, setNote] = useState(proxy?.note || '')
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    const handleSave = async () => {
        if (isLoading) return
        
        setIsLoading(true)
        setError(null)
        try {
            // Отправляем PUT запрос на сервер для сохранения заметки
            await apiClient.updateProxyNote(proxy.agentId || proxy.id, note)
            onSave(note)
        } catch (error) {
            console.error('Error saving note:', error)
            setError('Failed to save note. Please try again.')
        } finally {
            setIsLoading(false)
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && e.ctrlKey) {
            handleSave()
        } else if (e.key === 'Escape') {
            onCancel()
        }
    }

    return (
        <div style={{ 
            position: 'relative',
            width: '100%',
            height: '100%'
        }}>
            {error && (
                <div style={{
                    color: '#e67c87',
                    fontSize: 'var(--text-xs)',
                    padding: '4px 8px',
                    background: 'rgba(220, 53, 69, 0.1)',
                    border: '1px solid rgba(220, 53, 69, 0.3)',
                    borderRadius: 'var(--radius-sm)',
                    marginBottom: '4px',
                    position: 'absolute',
                    top: '-30px',
                    left: '0',
                    right: '0',
                    zIndex: 1000
                }}>
                    {error}
                </div>
            )}
            <div style={{ 
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                display: 'flex', 
                alignItems: 'center', 
                gap: 'var(--spacing-xs)',
                background: 'var(--black)',
                zIndex: 999,
                padding: '2px'
            }}>
            <input
                type="text"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder="Add a note..."
                style={{
                    background: 'var(--dark-gray)',
                    border: '1px solid var(--light-gray)',
                    borderRadius: 'var(--radius-sm)',
                    color: 'var(--text-light)',
                    padding: '4px 8px',
                    fontSize: 'var(--text-sm)',
                    flex: 1,
                    width: '100%',
                    minWidth: '120px'
                }}
                autoFocus
            />
            <button
                onClick={handleSave}
                disabled={isLoading}
                style={{
                    background: 'var(--primary-orange)',
                    border: 'none',
                    borderRadius: 'var(--radius-sm)',
                    color: 'var(--white)',
                    padding: '4px 8px',
                    fontSize: 'var(--text-xs)',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                    opacity: isLoading ? 0.7 : 1,
                    transition: 'var(--transition-normal)',
                    flexShrink: 0,
                    whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => {
                    if (!isLoading) {
                        e.target.style.backgroundColor = 'var(--dark-orange)'
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isLoading) {
                        e.target.style.backgroundColor = 'var(--primary-orange)'
                    }
                }}
            >
                {isLoading ? '...' : 'Save'}
            </button>
            <button
                onClick={onCancel}
                disabled={isLoading}
                style={{
                    background: 'var(--dark-gray)',
                    border: '1px solid var(--light-gray)',
                    borderRadius: 'var(--radius-sm)',
                    color: 'var(--text-light)',
                    padding: '4px 8px',
                    fontSize: 'var(--text-xs)',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                    opacity: isLoading ? 0.7 : 1,
                    transition: 'var(--transition-normal)',
                    flexShrink: 0,
                    whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => {
                    if (!isLoading) {
                        e.target.style.borderColor = 'var(--primary-orange)'
                        e.target.style.color = 'var(--primary-orange)'
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isLoading) {
                        e.target.style.borderColor = 'var(--light-gray)'
                        e.target.style.color = 'var(--text-light)'
                    }
                }}
            >
                Cancel
            </button>
            </div>
        </div>
    )
}

export default NoteEditor